import { NotifyForm } from "./NotifyForm";

const PRODUCT_IMAGE =
  "https://customer-assets.emergentagent.com/job_2722b5c0-3fc4-48ce-a082-cf7c47f5e4a4/artifacts/ug8hdi04_Activehuman%20D3%20drops.jpg";

export const Hero = () => {
  return (
    <section
      id="product"
      data-testid="hero-section"
      className="relative pt-32 md:pt-40 pb-20 md:pb-28 overflow-hidden"
    >
      {/* subtle grain texture */}
      <div className="absolute inset-0 ah-grain opacity-50 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center relative">
        {/* Left: copy */}
        <div className="lg:col-span-7 ah-reveal">
          <div className="flex items-center gap-3 mb-8">
            <span className="ah-hairline" />
            <span
              data-testid="hero-overline"
              className="text-xs uppercase tracking-[0.28em] font-semibold text-[#1A362D]"
            >
              Coming Soon
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-serif-display text-5xl md:text-6xl lg:text-7xl text-[#1A362D] leading-[1.04] tracking-tight font-medium"
          >
            Nature's most <em className="font-serif-display italic text-[#C29B62] font-normal">essential</em> nutrient,
            <br className="hidden md:block" /> in a single drop.
          </h1>

          <p
            data-testid="hero-subhead"
            className="mt-8 text-base md:text-lg text-[#4A5D56] max-w-xl leading-relaxed font-light"
          >
            Modern lifestyles often keep us indoors, away from one of nature's most important nutrients. Activehuman
            Vitamin&nbsp;D3 Drops are thoughtfully formulated to support your daily wellness routine — convenient,
            easy-to-use liquid drops suitable for all age groups.
          </p>

          <div className="mt-10">
            <NotifyForm testIdPrefix="hero" />
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-3 text-xs tracking-wide text-[#4A5D56]/80 uppercase">
            <span data-testid="hero-badge-1">600 IU per ml</span>
            <span className="w-1 h-1 rounded-full bg-[#C29B62]" />
            <span data-testid="hero-badge-2">60 Servings</span>
            <span className="w-1 h-1 rounded-full bg-[#C29B62]" />
            <span data-testid="hero-badge-3">All age groups</span>
          </div>
        </div>

        {/* Right: product image */}
        <div className="lg:col-span-5 relative ah-reveal" style={{ animationDelay: "0.15s" }}>
          <div className="relative bg-[#F3F5F1] p-6 md:p-10">
            <div className="absolute top-4 left-4 text-[10px] uppercase tracking-[0.3em] text-[#1A362D]/60">
              60 ml · 600 IU/ml
            </div>
            <div className="absolute bottom-4 right-4 text-[10px] uppercase tracking-[0.3em] text-[#C29B62]">
              Pre-launch
            </div>
            <img
              src={PRODUCT_IMAGE}
              alt="Activehuman Vitamin D3 Drops bottle"
              data-testid="hero-product-image"
              className="w-full h-[440px] md:h-[560px] object-cover object-left"
            />
          </div>

          {/* Decorative sun arc */}
          <div className="hidden lg:block absolute -top-12 -right-12 w-40 h-40 rounded-full border border-[#C29B62]/40" />
          <div className="hidden lg:block absolute -top-6 -right-6 w-24 h-24 rounded-full border border-[#C29B62]/30" />
        </div>
      </div>
    </section>
  );
};
